<template>
<div class="file-upload-link">
  <label :for="id">
    <span class="btn-link underline pointer">{{ $t(linkName) }} </span>
    <span v-if="showFileName && internalFile" @click.prevent="previewFile" class="mute pointer">{{ fileName }}</span>
    <span v-if="showFileName && canRemove && internalFile" @click.prevent="killFile" class="action pointer">x</span>
  </label>
  <input v-bind="$attrs" ref="fileUpload" @change="addFile" :id="id" :type="type" v-show="false">
</div>
</template>

<script>
import toastr from 'toastr'
export default {
  name: 'FileUploadLink',
  props: {
    id: {
      type: String,
      default: 'FileUpload'
    },
    linkName: {
      type: String,
      default: 'Choose File'
    },
    file: {
      type: Object
    },
    fileTypes: {
      type: Array,
      required: false
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    invalidFormatMessage: {
      type: String,
      default: 'Unsupported format'
    },
    staticFileName: {
      type: String,
      default: ''
    },
    showFileName: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  mounted () {
    if (this.file) this.internalFile = this.file
  },
  watch: {
    file (newFile) {
      if (newFile) this.internalFile = newFile
    }
  },
  data: () => ({
    type: 'file',
    internalFile: null
  }),
  computed: {
    fileName () {
      if (this.staticFileName !== '') return this.staticFileName

      return this.internalFile ? this.internalFile.name || this.internalFile.fileName : ''
    }
  },
  methods: {
    killFile (e) {
      this.$emit('removeFile', this.internalFile)
      this.resetInput(e)
      this.internalFile = null
    },
    addFile (e) {
      const file = e.target.files[0]
      if (this.fileTypes !== undefined) {
        const validFile = this.validateFileType(file)
        if (!validFile) {
          toastr.error(this.invalidFormatMessage)
          this.resetInput(e)
          return
        }
      }
      if (!file) return
      this.internalFile = file
      this.$emit('input', file)
      this.$emit('addFile', file)

      // when using static name, reset input to allow same file to be selected
      if (this.staticFileName !== '') {
        this.resetInput(e)
      }
    },
    previewFile () {
      if (this.internalFile.constructor.name === 'File') window.open(URL.createObjectURL(this.internalFile))
      else window.open(this.internalFile.url)
    },
    resetInput (e) {
      this.$refs.fileUpload.value = null
      this.type = 'string'
      this.type = 'file'
    },
    validateFileType (file) {
      const fileExtensionRegex = /\.[0-9a-z]+$/i
      const extension = file.name.match(fileExtensionRegex)
      if (!extension) return false
      return this.fileTypes.includes(extension[0].toLowerCase())
    }
  },
  i18n: {
    messages: {
      'en-US': {
        fileUploadLink: {}
      },
      'ja-JP': {
        fileUploadLink: {}
      }
    }
  }
}
</script>
<style scoped lang="scss">
label {
  span {
    margin-left: 0.5em;
  }
  span:first-child {
    margin-left: 0;
  }
}
.mute, .mute:hover {
  color: #777f8b;
}
.action, .action:hover {
  color: rgb(189, 8, 8);
}
.pointer {
  cursor: pointer;
}
</style>